module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"heading":{"add-crew-member":"Add Crew Member"}},"es":{"heading":{"add-crew-member":"Añadir miembro del personal"}}}')
  delete Component.options._Ctor
}
